import { AUTH_SESSION, LOGOUT } from './types';
const initialState = {
    user: {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        country: '',
        uiLanguage: '',
        communicationLanguage: '',
        accountType: '',
        uom: '',
        dateFormat: '',
        timeFormat: '',
        emailDay: [],
    },
    authTicket: {
        token: '',
        expires: 0,
        duration: 0,
    },
};
export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_SESSION:
            return {
                ...state,
                ...action.authSession,
            };
        case LOGOUT:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
